import { IAppState, isUserShareMember } from '@mafc/common';
import { EApiMiddlewareMethods } from 'config/redux/middlewares/api.middleware.types';
import {
  FETCH_SUBSTITUTES_API,
  REPLACE_SUBSTITUTE_API,
} from 'pages/NewCart/constants/api.constants';
import { Dispatch } from 'redux';
import {
  FETCH_SUBSTITUTES,
  FETCH_SUBSTITUTES_SUCCESS,
  SUBSTITUTE_REPLACEMENT,
  SUBSTITUTE_REPLACEMENT_FAIL,
  UPDATE_OOS_CURRENT_ITEM_INDEX,
  UPDATE_OOS_SELECTED_ITEMS,
} from '../constants/substitution.type';
import { INewCartEntry, INewCartShipment } from 'pages/NewCart/ICart';
import { EShipmentTypes } from 'services/shipments/types/shipments.types';
import { getGUID } from 'utils/cookies.util';

export const replaceSubstituteError = (data: boolean) => ({
  type: SUBSTITUTE_REPLACEMENT_FAIL,
  payload: data,
});

export const updateOOSSelectedItems = (data: number[]) => ({
  type: UPDATE_OOS_SELECTED_ITEMS,
  payload: data,
});

export const updateOOSCurrentItemIndex = (data: number) => ({
  type: UPDATE_OOS_CURRENT_ITEM_INDEX,
  payload: data,
});

export const resetSubstitutes = () => ({
  type: FETCH_SUBSTITUTES_SUCCESS,
  payload: { data: [] },
});

export const prepareSubstitutePayload = (
  shipments: INewCartShipment[],
  isNowUnavailableHour: boolean
) =>
  shipments
    .filter(
      ({ shipmentType, oosEntries }) =>
        ((shipmentType === EShipmentTypes.EXPRESS && !isNowUnavailableHour) ||
          shipmentType === EShipmentTypes.STANDARD_FOOD) &&
        oosEntries.length > 0
    )
    .map(({ shipmentType, oosEntries, pos }) => ({
      shipmentType,
      items: oosEntries.map(({ offerId, entryNumber }) => ({
        offerId,
        productId: entryNumber,
      })),
      pos,
    }));

export const fetchSubstitutes = (isNowUnavailableHour: boolean) => (
  dispatch: Dispatch,
  getState: () => IAppState
) => {
  const {
    cartData: { shipments = [] },
  } = getState().newCart;
  const guid = getGUID();
  const url = guid ? `${FETCH_SUBSTITUTES_API}&guid=${guid}` : FETCH_SUBSTITUTES_API;

  const shipmentsPayload = prepareSubstitutePayload(shipments, isNowUnavailableHour);

  if (shipmentsPayload.length) {
    dispatch({
      type: FETCH_SUBSTITUTES,
      payload: {
        apiVersion: 4,
        enableProgress: true,
        method: EApiMiddlewareMethods.POST,
        params: {
          lm: isUserShareMember(getState()),
        },
        data: { shipments: shipmentsPayload },
        url,
      },
    });
  }
};

const prepareReplacementPayload = (
  originalProduct: INewCartEntry,
  substituteProduct: INewCartEntry
) => {
  return [
    {
      original: {
        intent: originalProduct.intent,
        offerId: originalProduct.offerId,
        productId: originalProduct.entryNumber,
      },
      substitute: {
        intent: substituteProduct.intent,
        productId: substituteProduct.entryNumber,
        quantity: substituteProduct.quantity,
        serviceProductCode: [],
        offerId: substituteProduct.offerId,
        productName: substituteProduct.product && substituteProduct.product.name,
        pis: [substituteProduct.intent],
        imageUrl:
          substituteProduct.product &&
          substituteProduct.product.images &&
          substituteProduct.product.images.length > 0 &&
          substituteProduct.product.images[0].url,
        isSoldByWeight: substituteProduct.product && substituteProduct.product.soldByWeight,
        shopId:
          substituteProduct.product &&
          substituteProduct.product.mainOffer &&
          substituteProduct.product.mainOffer.shopCode,
        shopName:
          substituteProduct.product &&
          substituteProduct.product.mainOffer &&
          substituteProduct.product.mainOffer.shopName,
      },
    },
  ];
};

export const replaceSubstitute = (
  originalProduct: INewCartEntry,
  substituteProduct: INewCartEntry,
  oosCurrentItemIndex: number
) => (dispatch: Dispatch) => {
  const payload = prepareReplacementPayload(originalProduct, substituteProduct);
  const guid = getGUID();
  const url = guid ? `${REPLACE_SUBSTITUTE_API}&guid=${guid}` : REPLACE_SUBSTITUTE_API;

  dispatch({
    type: SUBSTITUTE_REPLACEMENT,
    payload: {
      apiVersion: 4,
      enableProgress: true,
      method: EApiMiddlewareMethods.POST,
      data: { items: payload },
      url,
      onSuccess: (data: any) => {
        if (data.errors && data.errors.length > 0) {
          dispatch(replaceSubstituteError(true));
        } else {
          dispatch(updateOOSCurrentItemIndex(oosCurrentItemIndex + 1));
        }
      },
    },
  });
};
